export function getCarsIdFromURL() {
    const params = new URLSearchParams(window.location.search);
    const carsId = parseInt(params.get("carsId") as string, 10);
    // tslint:disable-next-line:no-extra-boolean-cast
    if (!!carsId) {
        return carsId;
    }
    return undefined;
}
